import React from 'react';
import { Redirect, useParams } from 'react-router-dom';

/**
 * Path-segment TabSubrouters make their first visible tab pathless, so a deep
 * link to a stale or unknown `:tab` segment leaves TabSubrouter with no matching
 * route and a blank panel. This hook redirects any segment that isn't a
 * currently-visible (non-first) tab back to the tab bar's base URL.
 *
 * Returns a `<Redirect>` element to render (early-return it), or `null` when the
 * current segment is valid. Shared by the path-segment subrouters (Profile,
 * Identity, Compliance, Submissions, …) so the guard lives in one place.
 */
export function useUnknownTabRedirect(
  subroutes: ReadonlyArray<{ readonly path?: string }>,
  baseUrl: string
): React.ReactElement | null {
  const { tab } = useParams<{ tab?: string }>();
  const validTabPaths = subroutes
    .map((route) => route.path)
    .filter((path): path is string => Boolean(path));
  if (tab && !validTabPaths.includes(tab)) {
    return <Redirect to={baseUrl} />;
  }
  return null;
}
